export default {"src":"/_next/static/media/icon-car.80349ae7.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};